import { withNamespace } from '../helper';

const namespace = '@CUSTOMER';

export const GET_CUSTOMERS = withNamespace('GET_CUSTOMERS', namespace);
export const GET_CUSTOMERS_SUCCESS = withNamespace('GET_CUSTOMERS_SUCCESS', namespace);

export const CREATE_CUSTOMER = withNamespace('CREATE_CUSTOMER', namespace);
export const CREATE_CUSTOMER_SUCCESS = withNamespace('CREATE_CUSTOMER_SUCCESS', namespace);

export const UPDATE_CUSTOMER = withNamespace('UPDATE_CUSTOMER', namespace);
export const UPDATE_CUSTOMER_SUCCESS = withNamespace('UPDATE_CUSTOMER_SUCCESS', namespace);

export const UPDATE_CUSTOMER_AVATAR = withNamespace('UPDATE_CUSTOMER_AVATAR', namespace);
export const UPDATE_CUSTOMER_AVATAR_SUCCESS = withNamespace(
  'UPDATE_CUSTOMER_AVATAR_SUCCESS',
  namespace,
);

export const UPDATE_CUSTOMER_USERNAME = withNamespace('UPDATE_CUSTOMER_USERNAME', namespace);
export const UPDATE_CUSTOMER_USERNAME_SUCCESS = withNamespace(
  'UPDATE_CUSTOMER_USERNAME_SUCCESS',
  namespace,
);

export const GET_REFERENCE_DATA = withNamespace('GET_REFERENCE_DATA', namespace);
export const GET_REFERENCE_DATA_SUCCESS = withNamespace('GET_REFERENCE_DATA_SUCCESS', namespace);

export const GET_DETAIL = withNamespace('GET_DETAIL', namespace);
export const GET_DETAIL_SUCCESS = withNamespace('GET_DETAIL_SUCCESS', namespace);

export const SUBMIT_DATA = withNamespace('SUBMIT_DATA', namespace);
export const SUBMIT_DATA_SUCCESS = withNamespace('SUBMIT_DATA_SUCCESS', namespace);

export const DELETE = withNamespace('DELETE', namespace);
export const DELETE_SUCCESS = withNamespace('DELETE_SUCCESS', namespace);

export const UPDATE = withNamespace('UPDATE', namespace);

export const SET_LOADING = withNamespace('SET_LOADING', namespace);

export const REQUEST_ERROR = withNamespace('REQUEST_ERROR', namespace);
